module.exports = __webpack_public_path__ + "img/prize-04.9a380ed3.png";